<template>
  <slot />
  <BestBrandHome />
  <CartasInformativas v-if="modo_sistema === NEGOCIOS.NEUMATICOS" />
  <ResenasGrid />
  <div class="flex flex-col gap-2 justify-center text-center py-6 max-w-[1200px] w-full md:mx-auto md:py-8 p-5">
    <div class="hidden md:flex flex-col gap-6">
      <h2 class="text-center flex justify-center items-center font-bold text-lg md:text-2xl">
        CONOCE NUESTROS LOCALES
      </h2>
      <p class="font-semibold">
        Como líderes en el mercado, contamos con una gran variedad de marcas y
        modelos de neumáticos, baterías, frenos, entre otros.<br />
        Visítanos, deja tu auto en buenas manos.
      </p>
    </div>
    <MapChile />
  </div>
  <ServiciosIncluidos v-if="modo_sistema === NEGOCIOS.NEUMATICOS" />
  <ServiciosIncluidos v-if="modo_sistema === NEGOCIOS.BATERIAS" />
  <BannerTrabajadores />
</template>

<script setup>
import BestBrandHome from '@/components/Home/BestBrandHome.vue'
import ResenasGrid from '~/components/newhome/resenas/ResenasGrid.vue'
import CartasInformativas from '~/components/Cards/CartasInformativas.vue'
import MapChile from '@/components/Mapas/MapChile.vue'
import ServiciosIncluidos from '@/components/Home/servicios/ServiciosIncluidos.vue'
import BannerTrabajadores from '@/components/Home/banners/BannerTrabajadores.vue'
import { NEGOCIOS } from '~/constants/negocios'

defineProps({
  showBatteryWarning: {
    type: Boolean,
    default: true,
  },
});

const modo_sistema = useState('modo_sistema')
</script>
